import { render, staticRenderFns } from "./ProductionSelector.vue?vue&type=template&id=00237897&scoped=true&"
import script from "./ProductionSelector.vue?vue&type=script&lang=js&"
export * from "./ProductionSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00237897",
  null
  
)

export default component.exports